import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, } from '@ng-bootstrap/ng-bootstrap';
import { OnlyLNumbersValidator } from 'src/app/directives/only-numbers-validator.directive';
import { StandardIdModel } from 'src/app/models/api/standard-id.model';
import { UpdateOrganisationModel } from 'src/app/models/api/update-organisation.model';
import { Organisation } from 'src/app/models/organisation';
import { User } from 'src/app/models/user';
import { IdentityOrganisationApiClient } from 'src/app/services/api-clients/identity-organisation.api-client';
import { SettingsService } from '../settings.service';

@Component({
  templateUrl: './edit-organisation.modal.html',
})
export class EditOrganisationModal {


  /**
   * Whether this Modal can Create,Update or Delete its Organisation (True)
   * 
   * Or should Emit an updateOrganisation event (False)
   * 
   * CURRENTLY only Update is implemented
   */
  @Input() useModalStandAlone: boolean = false;
  /**
   * EMITS so that users of Stand alone modal can still act on succes
   */
  @Output() oganisationUpdated: EventEmitter<any> = new EventEmitter();



  private _organisation: Organisation = new Organisation;
  @Input('organisation') set organisation(val: Organisation) {
    this._organisation = val;
    this.neworganisation = false;
    if (val.organisation != null && val.organisation != undefined) {
      this.subscriptionLevel = val.organisation.subscriptionLevel;
      this.selectedWhitelabelProviderName = val.organisation.enterprise.name;
      this.selectedWhitelabelProviderId = +val.organisation.enterprise.id;
      this.whitelabelEnabled = val.organisation.whitelabelEnabled;
      this.customStorageEnabled = val.organisation.customStorageEnabled;
      this.organisationNameControl.patchValue(val.organisation.name);
      this.accountLicensesControl.patchValue(val.organisation.maxUserCount);
    }
  }
  get organisation(): Organisation {
    return this._organisation;
  }
  @Input() whitelabelProviders: StandardIdModel[] = [];
  @Output('updateOrganisation') updateOrganisation: EventEmitter<any> = new EventEmitter();
  subscriptionLevel: string = "Basic";
  user!: User;
  selectedWhitelabelProviderId!: number;
  selectedWhitelabelProviderName!: string;
  neworganisation: boolean = true;
  whitelabelEnabled: boolean = false;
  customStorageEnabled: boolean = false;
  form!: UntypedFormGroup;
  organisationNameControl!: FormControl;
  accountLicensesControl!: FormControl;

  constructor(private formBuilder: UntypedFormBuilder, private activeModal: NgbActiveModal, private identityOrganisationApiClient: IdentityOrganisationApiClient, private settingService: SettingsService) {
    this.user = this.settingService.user;
    this.accountLicensesControl = new FormControl('', [OnlyLNumbersValidator()]);
    this.organisationNameControl = new FormControl('', [Validators.required, Validators.minLength(2)]);
    this.form = this.formBuilder.group(
      {
        organisationName: this.organisationNameControl,
        accountLicenses: this.accountLicensesControl
      }
    );
  }

  selectWhiteLabelProvider(whitelabelProvider: StandardIdModel) {
    this.selectedWhitelabelProviderName = whitelabelProvider.name;
    this.selectedWhitelabelProviderId = +whitelabelProvider.id;

  }
  updateOrganisationValue(key: string, event: any) {
    if (key === "subscriptionLevel") {
      this.subscriptionLevel = event;
    }
  }

  updateSwitch(key: string, event: any) {
    if (key === 'enablePrivateBlob') {
      this.customStorageEnabled = (event.target as HTMLInputElement).checked;
    }
    else if (key === "enableBranding") {
      this.whitelabelEnabled = (event.target as HTMLInputElement).checked;
    }
  }

  save() {
    let organisationName = this.organisationNameControl.value;
    let accountLicenses = this.accountLicensesControl.value;
    if (this.organisation.organisation === null || this.organisation.organisation === undefined) {
      this.organisation.organisation = {};
    }
    this.organisation.organisation.Name = organisationName;
    this.organisation.organisation.MaxUserCount = accountLicenses;
    this.organisation.organisation.WhiteLabelProviderId = this.selectedWhitelabelProviderId;
    this.organisation.organisation.SubscriptionLevel = this.subscriptionLevel;
    this.organisation.organisation.CustomStorageEnabled = this.customStorageEnabled;
    this.organisation.organisation.WhitelabelEnabled = this.whitelabelEnabled;
    // normal behaviour
    if (!this.useModalStandAlone) {
      this.updateOrganisation.emit({ organisation: this.organisation });
      return;
    }

    // new Stand alone functionality
    var updateModel = ({
      organisationGuid: this.organisation.organisation.guid,
      name: organisationName,
      maxUserCount: +accountLicenses,
      subscriptionLevel: this.subscriptionLevel,
      WhiteLabelProviderId: this.selectedWhitelabelProviderId,
      customStorageEnabled: this.customStorageEnabled,
      whitelabelEnabled: this.whitelabelEnabled,


    } as UpdateOrganisationModel);

    this.identityOrganisationApiClient.updateOrganisationByModel(updateModel).subscribe(succes => {
      this.oganisationUpdated.emit();
      this.activeModal.close();
    });
  }

  close() {
    this.activeModal.close();
  }

}
